import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { AppDispatch, RootState } from '../../../../store';
import { setSummaryType } from '../../../../store/summaryTest/slice';
import Select, { SelectOption } from '../../../../components/UI/Select';
import { Heading } from '../../../../components/Typography';

const summaryTypeOptions: SelectOption[] = [
  { value: 'custom', label: 'Custom Summary' },
  { value: 'predefined', label: 'Predefined Summary' },
];

const SummaryTypeSelector: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const summaryType = useSelector((state: RootState) => state.summaryTest.summaryType);

  const handleSummaryTypeChange = (value: string | undefined) => {
    if (value === 'custom' || value === 'predefined') {
      dispatch(setSummaryType(value));
    }
  };

  return (
    <div>
      <Heading level={2}>2. Select Summary Type</Heading>
      <Select
        options={summaryTypeOptions}
        value={summaryType}
        onChange={handleSummaryTypeChange}
        fullWidth
      />
    </div>
  );
};

export default SummaryTypeSelector;
